<template>
  <b-card
    class="post mb-3"
    tag="article"
    no-body
  >
    <b-card-header header-tag="h4">
      <template v-if="full">
        {{ post.title }}
      </template>
      <b-link
        v-else
        :to="frontend ? { name: 'blog_post', params: { parish_id: post.parish.id, post_id: post.id } } : { name: 'cabinet_blog', query: { post: post.id } }"
      >
        {{ post.title }}
      </b-link>
    </b-card-header>

    <template v-if="full">
      <b-card-body
        vhtml="post.article"
        ref="article"
        class="pt-1"
      />
    </template>
    <template v-else>
      <b-card-body class="pt-1">
        <b-img
          v-if="post.image"
          :src="post.image"
          :alt="post.title"
          :width="150"
          :height="150"
          style="object-fit: cover;"
          class="float-left border-0 pt-1 mr-2 mb-2"
        />
        <div v-html="post.excerpt" />
        <div class="text-right">
          <b-button
            size="sm"
            variant="link"
            :to="frontend ? { name: 'blog', query: { parish: post.parish.id, post: post.id } } : { name: 'cabinet_blog', query: { post: post.id } }"
          >
            Читать далее
          </b-button>
        </div>
      </b-card-body>
    </template>

    <b-card-footer
      class="d-flex flex-row"
    >
      <small>
        {{ post.published | small }}
      </small>

      <div
        class="ml-auto mr-auto"
      >
        <social-sharing
          :url="postSocialLink"
          :title="postSocialTitle"
          :description="postSocialExcerpt"
          :quote="postSocialExcerpt"
          hashtags="#evangelielife"
          inline-template
        >
          <div class="networks d-inline-block">
            <network network="facebook">
              <a
                class="ml-1 btn btn-sm btn-social-icon btn-facebook text-white"
                v-b-tooltip="`Поделиться в Facebook`"
              >
                <font-awesome-icon :icon="['fab', 'facebook']" />
              </a>
            </network>
            <network network="vk">
              <a
                class="ml-1 btn btn-sm btn-social-icon btn-vk text-white"
                v-b-tooltip="`Поделиться в VKontakte`"
              >
                <font-awesome-icon :icon="['fab', 'vk']" />
              </a>
            </network>
            <network network="odnoklassniki">
              <a
                class="ml-1 btn btn-sm btn-social-icon btn-odnoklassniki text-white"
                v-b-tooltip="`Поделиться в Одноклассниках`"
              >
                <font-awesome-icon :icon="['fab', 'odnoklassniki']" />
              </a>
            </network>
            <network network="twitter">
              <a
                class="ml-1 btn btn-sm btn-social-icon btn-twitter text-white"
                v-b-tooltip="`Поделиться в Twitter`"
              >
                <font-awesome-icon :icon="['fab', 'twitter']" />
              </a>
            </network>
            <network network="whatsapp">
              <a
                class="ml-1 btn btn-sm btn-social-icon btn-whatsapp text-white"
                v-b-tooltip="`Поделиться в WhatsApp`"
              >
                <font-awesome-icon :icon="['fab', 'whatsapp']" />
              </a>
            </network>
            <network network="telegram">
              <a
                class="ml-1 btn btn-sm btn-social-icon btn-telegram text-white"
                v-b-tooltip="`Поделиться в Telegram`"
              >
                <font-awesome-icon :icon="['fab', 'telegram']" />
              </a>
            </network>
            <network network="viber">
              <a
                class="ml-1 btn btn-sm btn-social-icon btn-viber text-white"
                v-b-tooltip="`Поделиться в Viber`"
              >
                <font-awesome-icon :icon="['fab', 'viber']" />
              </a>
            </network>
            <network network="skype">
              <a
                class="ml-1 btn btn-sm btn-social-icon btn-skype text-white"
                v-b-tooltip="`Поделиться в Skype`"
              >
                <font-awesome-icon :icon="['fab', 'skype']" />
              </a>
            </network>
<!--            <span>-->
<!--              <a-->
<!--                class="ml-3 btn btn-sm btn-social-icon btn-link2 text-white"-->
<!--                v-b-tooltip="`Скопировать ссылку`"-->
<!--                @click.prevent="copyLink(postSocialLink)"-->
<!--              >-->
<!--                <font-awesome-icon :icon="['fas', 'link']" />-->
<!--              </a>-->
<!--            </span>-->
          </div>
        </social-sharing>
        <b-button
          variant="outline-primary"
          size="sm"
          v-b-tooltip="`Скопировать ссылку`"
          class="ml-3"
          style="max-height: 30px;"
          @click="copyLink(postSocialLink)"
        >
          <font-awesome-icon icon="link" />
        </b-button>
      </div>

      <div>
        <template v-if="frontend">
          <b-button
            size="sm"
            variant="outline-primary"
            class="float-right ml-1"
            v-b-tooltip="'Количество голосов'"
          >
            <font-awesome-icon :icon="['fas', 'heart']" />
            <b-badge variant="transparent">
              {{ post.votes.count }}
            </b-badge>
          </b-button>

          <b-button
            :to="{ name: 'blog_post', params: { parish_id: post.parish.id, post_id: post.id }, hash: '#comments' }"
            size="sm"
            variant="outline-primary"
            class="float-right ml-1"
            v-b-tooltip="'Количество комментариев'"
          >
            <font-awesome-icon :icon="['fas', 'comments']" />
            <b-badge variant="transparent">
              {{ post.comments.length }}
            </b-badge>
          </b-button>
        </template>
        <template v-else>
          <b-button
            v-if="isOwner"
            size="sm"
            variant="outline-primary"
            class="float-right ml-1"
            @click.stop="edit()"
            v-b-tooltip="'Редактировать'"
          >
            <font-awesome-icon :icon="['far', 'edit']" />
          </b-button>

          <b-button
            size="sm"
            variant="outline-primary"
            class="float-right ml-1"
            :pressed="post.votes.self"
            @click="vote()"
            :disabled="voting"
            v-b-tooltip="'Количество голосов'"
          >
            <font-awesome-icon
              v-if="!voting"
              :icon="['fas', 'heart']"
            />
            <font-awesome-icon
              v-else
              :icon="['fas', 'spinner']"
              spin
            />
            <b-badge variant="transparent">
              {{ post.votes.count }}
            </b-badge>
          </b-button>

          <b-button
            :to="{ name: 'cabinet_blog', query: { post: post.id }, hash: '#comments' }"
            size="sm"
            variant="outline-primary"
            class="float-right ml-1"
            v-b-tooltip="'Количество комментариев'"
          >
            <font-awesome-icon :icon="['fas', 'comments']" />
            <b-badge variant="transparent">
              {{ post.comments.length }}
            </b-badge>
          </b-button>
        </template>
      </div>
    </b-card-footer>
  </b-card>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { small } from '@/filters/date'

export default {
  filters: {
    small
  },
  components: {},
  props: {
    post: {
      type: Object,
      required: true
    },
    full: {
      type: Boolean,
      default: false
    },
    frontend: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    voting: false
  }),
  computed: {
    ...mapState('UserModule', {
      userID: 'id',
      isPriest: 'priest'
    }),
    ...mapState('ParishModule', {
      activeParish: 'current'
    }),
    socialNetworks () {
      return [
        { id: 'facebook', text: this.$t('social.facebook') },
        { id: 'vk', text: this.$t('social.vk') },
        { id: 'odnoklassniki', text: this.$t('social.odnoklassniki') },
        { id: 'twitter', text: this.$t('social.twitter') },
        { id: 'watsup', text: this.$t('social.facebook') }
      ]
    },
    postSocialLink () {
      const { href } = this.$router.resolve({
        name: 'blog_post',
        params: { parish_id: this.post.parish.id, post_id: this.post.id }
      })
      // return `${location.origin}${href}`
      return `https://api.evangelie.life/r${href}`
    },
    postSocialTitle () {
      return this.post.title
    },
    postSocialExcerpt () {
      const el = document.createElement('div')
      el.innerHTML = this.post.excerpt
      return (el.textContent || el.innerText || '')
        .replace(/\./g, '. ')
        .replace(/ {2}/g, ' ')
        .match(/.{1,140}(\s|$)/g)[0]
    },
    isOwner () {
      return this.isPriest && this.activeParish && this.activeParish.priest.id === this.userID
    },
    article () {
      return this.post.article
    }
  },
  watch: {
    article () {
      this.parseEmbedMedia()
    }
  },
  mounted () {
    if (this.full) {
      this.parseEmbedMedia()
    }
  },
  methods: {
    parseEmbedMedia () {
      this.$refs.article.innerHTML = this.article
      const el = this.$refs.article
      el.querySelectorAll('figure.media > oembed').forEach(media => {
        const url = media.getAttribute('url')
        if (!url) {
          return
        }
        axios.get('https://noembed.com/embed?url=' + url)
          .then(response => {
            if (!response.data.error) {
              media.parentElement.innerHTML = '<div class="videowrapper">' + response.data.html + '</div>'
            }
          })
      })
    },
    edit () {
      this.$emit('edit-post', this.post)
    },
    async vote () {
      this.voting = true
      await this.$store.dispatch('BlogModule/votePost', { parish: this.activeParish, post: this.post })
      this.voting = false
    },
    copyLink (link) {
      const el = document.createElement('textarea')
      el.value = link
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.$bvToast.toast('Ссылка скопирована в буфер обмена!', {
        variant: 'success',
        solid: true,
        toaster: 'b-toaster-top-center',
        noCloseButton: true
      })
    }
  }
}
</script>

<style lang="scss">
article.post {
  /*border: none;*/

  .card-header {
    background-color: transparent;
    border: none;
  }

  .card-body {
    p:last-child {
      margin-bottom: 0;
    }
  }
  a.btn-social-icon {
    > svg {
      display: block;
      margin: auto;
    }
  }
}
.networks {
  &>span {
    outline: none;
  }
}
</style>
